import { useEffect, useState } from "react";
import { Bookmark } from "lucide-react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ProjectCard } from "@/components/ProjectCard";
import { Loader, EmptyState } from "@/components/Loader";
import { Button } from "@/components/ui/button";

export default function Favorites() {
  const [projects, setProjects] = useState(null);
  useEffect(() => {
    api.get("/me/favorites").then((r) => setProjects(r.data)).catch(() => setProjects([]));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <p className="eyebrow text-primary">Sua coleção</p>
      <h1 className="mt-2 text-3xl font-extrabold tracking-tight">Meus favoritos</h1>
      <p className="mt-2 text-muted-foreground">Projetos que você salvou para construir depois.</p>

      <div className="mt-8">
        {projects === null ? <Loader /> : projects.length ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {projects.map((p, i) => <ProjectCard key={p.id} project={p} index={i} />)}
          </div>
        ) : (
          <EmptyState icon={Bookmark} title="Nenhum favorito ainda." subtitle="Salve projetos tocando no marcador para encontrá-los aqui."
            action={<Link to="/explorar"><Button className="rounded-full">Explorar projetos</Button></Link>} />
        )}
      </div>
    </div>
  );
}
